<script>
export default {
  props: {
    isIssueInvestigator: {
      type: Boolean,
      default: false,
    },
    isIssueUpdater: {
      type: Boolean,
      default: false,
    },
    isIssueReader: {
      type: Boolean,
      default: true,
    },
    isInvestigationTab: {
      type: Boolean,
    },
    isRecommendationTab: {
      type: Boolean,
    },
    airlineTierTypeId: {
      type: Number,
      default: null,
    },
    isCustomAlert: {
      type: Boolean,
      default: undefined,
    },
    internalUser: {
      type: Boolean,
      default: false,
    },
    tabIndex: {
      type: Number,
      default: 0,
    },
    isPreSubmittal: {
      type: Boolean,
      default: true,
    },
    isManuallyCreated: {
      type: Boolean,
      default: false,
    },
    isChronicRepeaters: {
      type: Boolean,
      default: undefined,
    },
  },
}
</script>
